(function () {
  var STORAGE_KEY = 'zocker_locale';
  var SHOPIFY_LOCALE = (document.documentElement.getAttribute('lang') || 'en').toLowerCase();
  var PATH_LOCALE = window.location.pathname.split('/')[1];
  var URL_LOCALE = new URLSearchParams(window.location.search).get('lang');
  var currentLocale = (URL_LOCALE === 'fr' || PATH_LOCALE === 'fr' || SHOPIFY_LOCALE.indexOf('fr') === 0) ? 'fr' : 'en';
  document.documentElement.setAttribute('lang', currentLocale);

  var dictionary = {
    fr: {
      'Home': 'Accueil',
      'Shop': 'Boutique',
      'Shop All': 'Toute la boutique',
      'Blog': 'Blogue',
      'Contact': 'Contact',
      'Account': 'Compte',
      'Wishlist': 'Liste de souhaits',
      'Cart': 'Panier',
      'Your Cart': 'Votre panier',
      'Subtotal': 'Sous-total',
      'Checkout': 'Paiement',
      'View Cart': 'Voir le panier',
      'Compare': 'Comparer',
      'Compare (0)': 'Comparer (0)',
      'Back to top': 'Retour en haut',
      'Search': 'Rechercher',
      'Shop Now': 'Acheter maintenant',
      'View All': 'Voir tout',
      'New Arrivals': 'Nouveautés',
      'Follow Every Drop.': 'Suivez chaque lancement.',
      'Get The First Drop.': 'Soyez les premiers informés.',
      'Notify Me': 'Prévenez-moi',
      'Sold Out': 'Épuisé',
      'Add to Cart': 'Ajouter au panier',
      'Buy it now': 'Acheter maintenant',
      'Quantity': 'Quantité',
      'Color': 'Couleur',
      'Size': 'Taille',
      'Apparel Size': 'Taille vêtement',
      'Shoe Size': 'Pointure',
      'Filters': 'Filtres',
      'Category': 'Catégorie',
      'Clear All': 'Tout effacer',
      'Apply Price': 'Appliquer le prix',
      'Min': 'Min',
      'Max': 'Max',
      'results': 'résultats',
      'products': 'produits',
      'Thickness': 'Épaisseur',
      'Choose product size': 'Choisir la taille du produit',
      'Size guide': 'Guide des tailles',
      'Detailed Info': 'Informations détaillées',
      'Specifications': 'Spécifications',
      'Warranty Policy': 'Politique de garantie',
      'Brand': 'Marque',
      'Related Products': 'Produits associés',
      'Product': 'Produit',
      'Price': 'Prix',
      'Availability': 'Disponibilité',
      'In stock': 'En stock',
      'Out of stock': 'Rupture de stock',
      'Filter': 'Filtrer',
      'Filters': 'Filtres',
      'Sort': 'Trier',
      'Sort by': 'Trier par',
      'Best Selling': 'Meilleures ventes',
      'Price, low to high': 'Prix croissant',
      'Price, high to low': 'Prix décroissant',
      'Alphabetically, A-Z': 'Alphabétique, A-Z',
      'Alphabetically, Z-A': 'Alphabétique, Z-A',
      'Date, new to old': 'Date, du plus récent au plus ancien',
      'Date, old to new': 'Date, du plus ancien au plus récent',
      'Let\'s Talk Pickleball.': 'Parlons pickleball.',
      'Questions? Feedback? We\'re here for you.': 'Questions? Commentaires? Nous sommes là pour vous.',
      'Name': 'Nom',
      'Email': 'Courriel',
      'Phone': 'Téléphone',
      'Message': 'Message',
      'Send Message': 'Envoyer le message',
      'Address': 'Adresse',
      'Subscribe': 'S’abonner',
      'your@email.com': 'votre@courriel.com',
      'Read More': 'Lire la suite',
      'Continue Reading': 'Continuer la lecture',
      'Previous': 'Précédent',
      'Next': 'Suivant',
      'Close': 'Fermer',
      'POWER. PRECISION. PICKLEBALL.': 'PUISSANCE. PRÉCISION. PICKLEBALL.',
      'Power.': 'Puissance.',
      'Precision.': 'Précision.',
      'Pickleball.': 'Pickleball.',
      'GET THE FIRST DROP.': 'SOYEZ LES PREMIERS INFORMÉS.',
      'READY TO PLAY?': 'PRÊT À JOUER?',
      'SHOP THE COLLECTION': 'MAGASINER LA COLLECTION',
      'VIEW': 'VOIR',
      'ALL POSTS': 'TOUS LES ARTICLES',
      'Quick Shop': 'Achat rapide',
      '+ ADD': '+ AJOUTER',
      'IN STOCK': 'EN STOCK',
      'SOLD OUT': 'ÉPUISÉ',
      'NEW ARRIVALS': 'NOUVEAUTÉS',
      '// 02 — CATEGORIES': '// 02 — CATÉGORIES',
      '// 03 — NEW ARRIVALS': '// 03 — NOUVEAUTÉS',
      '// 04 — PLAYERS TRUST ZOCKER': '// 04 — LES JOUEURS FONT CONFIANCE À ZOCKER',
      '// 05 — SEE US IN ACTION': '// 05 — VOYEZ-NOUS EN ACTION',
      '// 06 — FROM THE BLOG': '// 06 — DU BLOGUE',
      'Pickleball Paddles': 'Raquettes de pickleball',
      'Pickleball Balls': 'Balles de pickleball',
      'Pickleball Shoes': 'Chaussures de pickleball',
      'Pickleball Apparel': 'Vêtements de pickleball',
      'Pickleball Accessories': 'Accessoires de pickleball',
      'PICKLEBALL PADDLES': 'RAQUETTES DE PICKLEBALL',
      'PICKLEBALL BALLS': 'BALLES DE PICKLEBALL',
      'PICKLEBALL SHOES': 'CHAUSSURES DE PICKLEBALL',
      'PICKLEBALL APPAREL': 'VÊTEMENTS DE PICKLEBALL',
      'PICKLEBALL ACCESSORIES': 'ACCESSOIRES DE PICKLEBALL',
      'Red': 'Rouge',
      'Gray': 'Gris',
      'Grey': 'Gris',
      'Black': 'Noir',
      'Green': 'Vert',
      'Gold': 'Or',
      'Blue': 'Bleu',
      'Pink': 'Rose',
      'White': 'Blanc',
      'Mint': 'Menthe',
      'Orange': 'Orange',
      'White / Blue': 'Blanc / Bleu',
      'Orange / Blue': 'Orange / Bleu',
      'White / Grey': 'Blanc / Gris',
      'Black / Pink': 'Noir / Rose',
      'Blue / Orange': 'Bleu / Orange',
      'Green / Orange': 'Vert / Orange',
      'Pink / Purple': 'Rose / Violet',
      'Black / Orange': 'Noir / Orange',
      'Red / Black': 'Rouge / Noir',
      'White / Pink': 'Blanc / Rose',
      'Blue / Purple': 'Bleu / Violet',
      'White / Orange': 'Blanc / Orange'
    }
  };

  function normalize(text) {
    return (text || '').replace(/\s+/g, ' ').trim();
  }

  function translateText(text) {
    var map = dictionary[currentLocale];
    if (!map) return text;
    var normalized = normalize(text);
    if (!normalized) return text;
    var lowerMap = {};
    Object.keys(map).forEach(function (key) { lowerMap[key.toLowerCase()] = map[key]; });
    var prefixMatch = normalized.match(/^\/\/\s*(.+)$/);
    if (prefixMatch) {
      var prefixKey = prefixMatch[1];
      var prefixTranslation = map[prefixKey] || lowerMap[prefixKey.toLowerCase()];
      if (prefixTranslation) return text.replace(prefixKey, prefixTranslation);
    }
    var withoutCount = normalized.replace(/\s*\([^)]*\)$/, '');
    return map[normalized] || lowerMap[normalized.toLowerCase()] || map[withoutCount] || lowerMap[withoutCount.toLowerCase()] || text;
  }

  function shouldSkip(node) {
    if (!node || !node.parentElement) return true;
    var tag = node.parentElement.tagName;
    return ['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA', 'INPUT', 'SELECT', 'OPTION'].indexOf(tag) !== -1;
  }

  function translateNodeText(root) {
    if (currentLocale !== 'fr') return;
    var walker = document.createTreeWalker(root || document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (shouldSkip(node)) return NodeFilter.FILTER_REJECT;
        return normalize(node.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      var translated = translateText(node.nodeValue);
      if (translated !== node.nodeValue) node.nodeValue = translated;
    });
  }

  function translateAttributes(root) {
    if (currentLocale !== 'fr') return;
    Array.prototype.forEach.call((root || document).querySelectorAll('[aria-label], [placeholder], [title], input[value], button[value]'), function (el) {
      ['aria-label', 'placeholder', 'title', 'value'].forEach(function (attr) {
        if (!el.hasAttribute || !el.hasAttribute(attr)) return;
        var value = el.getAttribute(attr);
        var translated = translateText(value);
        if (translated !== value) el.setAttribute(attr, translated);
      });
    });
  }

  function updateLanguageUi() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-zocker-lang]'), function (el) {
      var isActive = el.getAttribute('data-zocker-lang') === currentLocale;
      el.classList.toggle('text-black', isActive);
      el.classList.toggle('font-bold', isActive);
      el.classList.toggle('text-neutral-400', !isActive);
      el.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  }

  function localizeInternalLinks(root) {
    var scope = root || document;
    Array.prototype.forEach.call(scope.querySelectorAll ? scope.querySelectorAll('a[href]') : [], function (link) {
      if (link.hasAttribute('data-zocker-lang')) return;
      var rawHref = link.getAttribute('href');
      if (!rawHref || rawHref.charAt(0) !== '/' || rawHref.indexOf('//') === 0) return;
      if (rawHref.indexOf('/admin') === 0 || rawHref.indexOf('/cdn') === 0 || rawHref.indexOf('/cart') === 0 && link.getAttribute('href') === '/cart.js') return;
      if (currentLocale === 'fr') {
        if (!/^\/fr(?=\/|$)/.test(rawHref)) {
          link.setAttribute('href', '/fr' + (rawHref === '/' ? '' : rawHref));
        }
      } else {
        if (/^\/fr(?=\/|$)/.test(rawHref)) {
          link.setAttribute('href', rawHref.replace(/^\/fr(?=\/|$)/, '') || '/');
        }
      }
    });
  }

  function applyTranslations(root) {
    translateNodeText(root || document.body);
    translateAttributes(root || document);
    updateLanguageUi();
    localizeInternalLinks(root || document);
  }

  window.ZockerLanguage = {
    current: currentLocale,
    switch: function (locale) {
      locale = locale === 'fr' ? 'fr' : 'en';
      localStorage.setItem(STORAGE_KEY, locale);
      var url = new URL(window.location.href);
      url.searchParams.delete('lang');
      if (locale === 'fr') {
        if (!/^\/fr(?=\/|$)/.test(url.pathname)) {
          url.pathname = '/fr' + (url.pathname === '/' ? '' : url.pathname);
        }
      } else {
        url.pathname = url.pathname.replace(/^\/fr(?=\/|$)/, '') || '/';
      }
      window.location.href = url.toString();
    },
    apply: applyTranslations
  };

  document.addEventListener('click', function (event) {
    var trigger = event.target && event.target.closest && event.target.closest('[data-zocker-lang]');
    if (!trigger) return;
    var locale = trigger.getAttribute('data-zocker-lang');
    if (locale !== 'en' && locale !== 'fr') return;
    event.preventDefault();
    window.ZockerLanguage.switch(locale);
  });

  document.addEventListener('DOMContentLoaded', function () {
    applyTranslations(document.body);
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes && Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          if (node.nodeType === 1) applyTranslations(node);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
